module.exports = __webpack_public_path__ + "img/location.e3fb2fc.svg";